<template>
  <div class="rs-enroll-container">
    <div class="content">
      <div class="card">
        <div class="label" @click="showLabel">
          机构权益
        </div>
        <van-form @submit="onSubmit">
          <van-cell-group inset>
          <van-field required readonly v-model="form1.type" name="申请类型" label="申请类型" placeholder="请选择市级/机构"
            @click="typePickerVisible = true" />
          <van-field required v-model="form1.school" name="单位名称" label="单位名称" placeholder="请输入单位名称，不能写简称"
            :rules="rules.school" />
          <van-field required v-model="form1.contacts" name="指定联系人" label="指定联系人" placeholder="请输入指定联系人姓名"
            :rules="rules.contacts" />
          <van-field required v-model="form1.mobile" name="联系电话" label="联系电话" placeholder="请填写联系人手机号"
            :rules="rules.mobile" />
          <van-field required name="机构简介" label="机构简介">
            <template #input>
              <div class="uploader" style="padding-bottom: 170px">
                <van-uploader v-model="form1.schoolUrl" accept=".doc,.docx,.pdf" upload-icon="plus" multiple
                  :max-size="20 * 1024 * 1024" :after-read="onFilesAfterRead" :before-delete="onFilesDelete" />
                <div class="tip">
                  支持word、pdf格式文档，IOS通过微信上传，安卓直接打开文件管理器上传。
                </div>
              </div>
            </template>
          </van-field>
          <van-field required name="服务案例" label="服务案例">
            <template #input>
              <div class="uploader" style="padding-bottom: 170px">
                <van-uploader v-model="form1.serviceCaseUrl" accept=".doc,.docx,.pdf" upload-icon="plus" multiple
                  :max-size="20 * 1024 * 1024" :after-read="onFilesAfterRead" :before-delete="onFilesDelete" />
                <div class="tip">
                  支持word、pdf格式文档，IOS通过微信上传，安卓直接打开文件管理器上传。
                </div>
              </div>
            </template>
          </van-field>
          <div class="submit-button-warp">
            <van-button class="submit-button" type="primary" native-type="submit">
              提交
            </van-button>
          </div>
          </van-cell-group>
        </van-form>
        <van-popup v-model:show="typePickerVisible" position="bottom">
          <van-picker :columns="typeList" @confirm="onTypeConfirm" @cancel="typePickerVisible = false"
            item-height="80" />
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import pattern from "@/utils/pattern"
import api_common from "@/assets/api/api_common"
import api_activity from "@/assets/api/api_activity"
import { Dialog, Notify } from "vant"
import { AuthMixin } from "@/assets/utils/mixin"

// eslint-disable-next-line no-undef

export default {
  // "最美红色故事发声人"视频、征文报名
  mixins: [AuthMixin],
  name: "wxcarnivalReporterApplyInstitution",
  data() {
    return {
      type: 3,
      form1: {},
      checked: '',
      typeList: ["市级", "机构"],
      rules: {
        school: [{ required: true, message: "单位名称不能为空" }],
        contacts: [{ required: true, message: "指定联系人不能为空" }],
        mobile: [
          { required: true, message: "联系电话不能为空" },
          { pattern: pattern.mobile, message: "联系电话格式错误" },
        ],
        schoolUrl: [{ required: true, message: "机构简介不能为空" }],
        serviceCaseUrl: [{ required: true, message: "服务案例不能为空" }],
      },
      typePickerVisible: false,
      // eslint-disable-next-line no-undef
      uploader: new AliyunUpload.Vod({
        timeout: 60000,
        partSize: 1048576,
        parallel: 5,
        retryCount: 3,
        retryDuration: 2,
        region: "cn-shanghai",
        userId: "12312312312413",
        // 添加文件成功
        addFileSuccess: this.handleAddFileSuccess,
        // 开始上传
        onUploadstarted: this.handleOnUploadstarted,
        // 文件上传成功
        onUploadSucceed: this.handleOnUploadSucceed,
        // 文件上传失败
        onUploadFailed: this.handleOnUploadFailed,
        // 取消文件上传
        onUploadCanceled: this.handleOnUploadCanceled,
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: this.handleOnUploadProgress,
        // 上传凭证超时
        onUploadTokenExpired: this.handleOnUploadTokenExpired,
        // 全部文件上传结束
        onUploadEnd: this.handleOnUploadEnd,
      }),
    }
  },
  methods: {
    onTypeConfirm(val) {
      this.form1.type = val
      this.typePickerVisible = false
    },
    showLabel() {
      Dialog.alert({
        title: '机构权益',
        messageAlign: 'left',
        message: '1. 审核通过后，将统一授权“光明少年读者服务点”牌匾。\n2.持有牌匾的学校将享有光明小记者会员项目的优先合作权益以及相关资源支持。\n3.授牌有效期：壹年',
      }).then(() => {
        // on close
      });
    },


    // 表单提交
    async onSubmit() {
      let params = {}
      let schoolUrl = this.form1.schoolUrl?.map(item => {
        if (item.message === "上传成功") {
          return { name: item.file.name, url: item.url }
        }
      })
      if (!schoolUrl?.length) {
        Notify({ type: "danger", message: '提交失败，机构简介不能为空' })
        return
      }
      let serviceCaseUrl = this.form1.serviceCaseUrl?.map(item => {
        if (item.message === "上传成功") {
          return { name: item.file.name, url: item.url }
        }
      })
      if (!serviceCaseUrl?.length) {
        Notify({ type: "danger", message: '提交失败，服务案例不能为空' })
        return
      }
      params = {
        type: this.type,
        mobile: this.form1.mobile,
        school: this.form1.school,
        content: JSON.stringify({ ...this.form1, schoolUrl, serviceCaseUrl }),
      }

      api_activity.addReporterNew(params).then((res) => {
        if (res.errcode !== 0) {
          Notify({ type: "danger", message: res.errmsg })
          return
        }
        if (!res.data) {
          Notify({ type: "danger", message: '提交失败，请联系工作人员处理' })
          return
        }
        Dialog.alert({
          title: "提示",
          message: "您的申请已提交",
        }).then(() => {
          this.form1 = {}
          // localStorage.removeItem('form1');
        })
      })
    },
    // 上传作品照片
    onFilesAfterRead(files) {
      let tmpFiles = files
      if (!(files instanceof Array)) {
        tmpFiles = [files]
      }
      tmpFiles.forEach((file) => {
        file.status = "uploading"
        file.message = "上传中..."
        let upload = api_common.uploadImage
        console.log('file', file)
        const extension = file.file.name.split('.').pop(); // 获取文件后缀
        if (extension === 'docx' || extension === 'doc' || extension === 'pdf') {
          upload = api_common.uploadFile
        } else {
          file.status = "failed"
          file.message = "上传失败"
          file.url = ""
          Dialog.alert({
            title: "提示",
            message: "请上传指定格式文件",
          })
          return
        }
        upload(file.file).then((res) => {
          if (res.errcode === 0) {
            file.status = "success"
            file.message = "上传成功"
            file.url = "https://wxfactory.zhmobi.com" + res.url
          } else {
            file.status = "failed"
            file.message = "上传失败"
            file.url = ""
          }
        })
      })
    },
    // 删除作品
    onFilesDelete() {
      return true
    },
    // 视频添加成功回调
    handleAddFileSuccess() {
      this.uploader.startUpload()
    },
    // 视频开始上传回调
    async handleOnUploadstarted(uploadInfo) {
      if (!uploadInfo.videoId) {
        const params = { CateId: "1000425120", FileName: uploadInfo.file.name }
        const res = await api_common.createUploadVideo(params)
        if (res.errcode !== 0) {
          return
        }
        this.uploader.setUploadAuthAndAddress(
          uploadInfo,
          res.data.UploadAuth,
          res.data.UploadAddress,
          res.data.VideoId
        )
      }
    },
    // 视频上传成功回调
    handleOnUploadSucceed(uploadInfo) {
      const url = "视频作品"
      const videoId = uploadInfo.videoId
      this.form1.worksUrl = [{ url, status: "success", message: "上传成功" }]
      this.form1.videoId = videoId
    },
    // 视频上传失败回调
    handleOnUploadFailed(uploadInfo, code, message) {
      console.log("handleOnUploadFailed", uploadInfo, code, message)
    },
    // 视频上传取消回调
    handleOnUploadCanceled(uploadInfo, code, message) {
      console.log("handleOnUploadCanceled", uploadInfo, code, message)
    },
    // 视频上传进度回调
    handleOnUploadProgress(uploadInfo, totalSize, progress) {
      console.log(progress)
    },
    // 视频上传凭证超时回调
    handleOnUploadTokenExpired(uploadInfo) {
      console.log("handleOnUploadTokenExpired", uploadInfo)
    },
    // 视频上传完成回调
    handleOnUploadEnd(uploadInfo) {
      console.log("handleOnUploadEnd", uploadInfo)
    },
  },
  mounted() {
    this.initWxConfig({
      itemName: "“光明小记者嘉年华”视频、征文报名",
      desc: "光明小记者嘉年华”视频、征文报名",
      pic: "https://xst.olomobi.com/img/top.66b4c33c.jpg",
      link: `activity/carnival/enroll`,
    })
  },
  // created() {
  // const cached1 = localStorage.getItem('form1');
  // if (cached1) {
  //     this.form1 = JSON.parse(cached1);
  // }
  // },
  // watch:{
  //  form1: {
  //       handler(newVal) {
  //           localStorage.setItem('form1', JSON.stringify(newVal));
  //       },
  //       deep: true
  //   },
  // }
}
</script>
<style lang="less" scoped>
.rs-enroll-container {
  // @media (max-width: 700px) {
  //   min-width: auto;
  //   // 按屏幕比例缩小
  //   transform: scale(0.7); /* 缩放为原来的80% */
  //   transform-origin: center top; /* 从左上角开始缩放 */
  // }
  width: 100%;
  position: relative;

  .content {
    margin: 0px;
    margin-top: -4px;
    background-color: #56b0fe;
    padding: 20px;

    .card {
      background-color: white;
      border-radius: 10px;
      padding: 20px;

      .label {
        position: absolute;
        top: 90px;
        right: 0px;
        font-size: 28px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        width: 140px;
        padding: 10px;
        border-radius: 20px 0px 0px 20px;
        background-color: #56b0fe;
        z-index: 9;
        box-shadow: -2px 3px 5px 0px rgba(0, 0, 0, 0.75);
      }

      .uploader {
        position: relative;
        width: 100%;
        padding-bottom: 140px;

        .case {
          position: relative;

          .img-case {
            width: 150px;
          }

          .img-case-txt {
            position: absolute;
            right: 0px;
            bottom: 125px;
            width: 150px;
            text-align: center;
            color: #ccc;
            background-color: #cccccc70;
          }
        }

        .tip {
          position: absolute;
          bottom: 0px;
          font-size: 20px;
          line-height: 1.5;
          color: gray;
          margin: 0px;
        }
      }

      .submit-button-warp {
        width: 100%;
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;

        .submit-button {
          width: 300px;
          border-radius: 10px;
          background-color: #56b0fe;
          border-color: #56b0fe;
        }
      }
    }
  }
}

label {
  font-size: 24px;
}
</style>

<style>
.van-tabs__nav--card {
  margin: 0 !important;
}

.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #56b0fe;
}
</style>
